import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=0c6706a0"
import script from "./PersonalSettings.vue?vue&type=script&lang=js"
export * from "./PersonalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports